window.coat = require("mithril-coat/build/coat.js")
window.jQuery = window.$ = require("jquery/dist/jquery.min.js")
muse.track = require("musecoreui/tracking/muse_track.coffee")


// WEBPACK FOOTER //
// ./static/coffee/apps/base.coffee